var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar-wrapper",class:{'avatar--centered': _vm.centered},on:{"click":_vm.handleClick}},[(!_vm.initials)?_c('img',{staticClass:"user-avatar border-gray",class:[
        _vm.size && ("avatar-" + _vm.size),
        {
          'avatar-square': !_vm.circle,
          'avatar--no-radius': _vm.noRadius,
          'avatar--autosize': _vm.autoSize
        }],attrs:{"src":_vm.avatarUrl}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }